// Footer.js 

const currentYear = new Date().getFullYear();

export default function Footer() {
    return <footer><small>Copyright © {currentYear} Delaxiox – All Rights Reserved.</small></footer>;
}